import { render, staticRenderFns } from "./QuotationSent.vue?vue&type=template&id=0e53cd26&scoped=true"
import script from "./QuotationSent.vue?vue&type=script&lang=js"
export * from "./QuotationSent.vue?vue&type=script&lang=js"
import style0 from "./QuotationSent.vue?vue&type=style&index=0&id=0e53cd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53cd26",
  null
  
)

export default component.exports